module.exports = __webpack_public_path__ + "img/03.19f4e606.png";